<template>
  <Transition>
    <div class="navbar-content align-items-center shadow-lg bg-dark text-light border-dark" v-if="showModalMinimizeCall">
      <a class="text-light m-2" @click="maximizeCall()">
        <i class="mdi mdi-arrow-expand mdi-24px"></i>
      </a>
      <div class="flex-container">
        <div class="text-left">
          <p class="h5 font-weight-bold"> {{ isChatPrivacy(phone_call.name) }} </p>
          <p class="font-weight-light"> {{ isChatPrivacy(phone_call.phone_number) }} </p>
        </div>
      </div>
      <div class="align-items-center text-center">
        <p class="h5 font-weight-bold"> {{ phone_call.channel }} </p>
        <p class="font-weight-bold text-secondary" v-if="call.duration != 0"> {{ call.duration }} </p>
        <p class="font-weight-bold text-secondary" v-else> {{ phone_call.status }} </p>
      </div>
      <ul class="navbar-nav text-center" v-if="call.duration == 0">
        <li class="nav-item">
          <el-button circle class="btn btn-danger btn-icon float-left" @click="handleEndPhoneCall">
            <i class="mdi mdi-phone-hangup"></i>
          </el-button>
        </li>
        <li class="nav-item" v-if="call_session.originator === 'remote'">
          <el-button circle class="btn btn-success btn-icon float-right mr-4" @click="handleAnswerIncomingCall">
            <i class="mdi mdi-phone"></i>
          </el-button>
        </li>
      </ul>
      <ul class="navbar-nav text-center" v-if="call.duration !== 0">
        <li class="nav-item">
          <el-button circle class="btn btn-secondary btn-icon float-left ml-4" @click="showNotesModal">
            <i class="mdi mdi-note-text"></i>
          </el-button>
        </li>
        <!-- <li class="nav-item">
          <el-button circle class="btn btn-secondary btn-icon right-px" @click="handleVolumePhoneCall">
            <i :class="phone_call.volume"></i>
          </el-button>
        </li> -->
        <!-- <li class="nav-item">
          <el-button v-if="isEnableVideoCallFeature" circle class="btn btn-secondary btn-icon right-px" @click="handlerCamPhoneCall">
            <i :class="phone_call.video"></i>
          </el-button>
        </li> -->
        <li class="nav-item">
          <el-button circle class="btn btn-secondary btn-icon" @click="handlerMicPhoneCall">
            <i :class="phone_call.mic"></i>
          </el-button>
        </li>
        <li class="nav-item">
          <el-button circle class="btn btn-danger btn-icon" @click="handleEndPhoneCall">
            <i class="mdi mdi-phone-hangup mdi-22px"></i>
          </el-button>
        </li>
      </ul>
    </div>
    <!-- <div v-if="isEnableVideoCallFeature && showVideo" class="mt-3">
      <transition mode="in-out">
        <div class="video-mini" v-show="showVideo">
          <video id="miniVideo" ref="miniVideo" autoplay playsinline></video>
        </div>
      </transition>
    </div> -->
  </Transition>
</template>

<script>
// import moment from 'moment';
// import JsSIP from 'jssip';
import { toSvg } from 'jdenticon';
// import popupErrorMessages from '@/library/popup-error-messages';

export default {
  name: 'PreviewMinimizeCall',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    call_session: {
      type: Object,
      default() {
        return {};
      },
    },
    phone_call: {
      type: Object,
      default() {
        return {};
      },
    },
    call: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showModalMinimizeCall: false,
      showVideo: false,
      isMutedCall: false,
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    isEnableVideoCallFeature() {
      return this.activeWorkspace.products && this.activeWorkspace.products[0].pricing.whatsapp.enable_video_call_feature;
    },
  },
  methods: {
    identicons(value) {
      return toSvg(value, '75');
    },
    onHide() {
      this.$emit('onHide');
    },
    handlerMicPhoneCall() {
      // this.isMutedCall = !this.isMutedCall;
      // this.phone_call.mic = this.isMutedCall ? 'mdi mdi-microphone-off mdi-22px' : 'mdi mdi-microphone mdi-22px';
      this.$emit('handleMicPhoneCall');
    },
    handlerCamPhoneCall() {
      // this.isOffCam = !this.isOffCam;
      // this.phone_call.video = !this.isOffCam ? 'mdi mdi-video-off mdi-22px' : 'mdi mdi-video mdi-22px';
      this.$emit('handleCamPhoneCall');
    },
    handleVolumePhoneCall() {
      if (this.phone_call.volume === 'mdi mdi-volume-low mdi-22px') {
        this.phone_call.volume = 'mdi mdi-volume-source mdi-22px';
      } else {
        this.phone_call.volume = 'mdi mdi-volume-low mdi-22px';
      }
    },
    handleAnswerIncomingCall() {
      this.$parent.handleAnswerIncomingCall();
    },
    handleEndPhoneCall() {
      this.$parent.handleEndPhoneCall();
    },
    maximizeCall() {
      this.$parent.handleMaximizePhoneCall();
    },
    showNotesModal() {
      this.$parent.handleShowNotesModal();
    },
    isChatPrivacy(number) {
      let phone_number = number;
      if (phone_number && this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (number.charAt(0) === '0') {
          phone_number = number.replace('0', '62');
        }
        const validateRegex = /^\+?[1-9][0-9]{4,14}$/;
        if (validateRegex.test(`${phone_number}`)) {
          return `${phone_number.substring(0, 2)}********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
  },
  watch: {
    show() {
      this.showModalMinimizeCall = this.show;
    },
  },
};
</script>

<!-- <style>
.bg-dark {
  background-color: #101623 !important;
}
.modal-content {
  border: 2px solid #474747;
  background-color: #101623;
  border-radius: 1.135rem;
}
.modal-header {
  /* border-bottom: 1px solid #474747; */
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.modal-body {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.border-header-call {
  border-bottom: 2px solid #474747 !important;
}
</style> -->
<style>
.flex-container {
  display: flex;
  justify-content: space-between;
  margin-inline-end: auto;
}
.main-wrapper .page-wrapper .page-content .minimize-call {
  margin-top: 105px;
}
.btn.btn-icon {
  width: 35px !important;
  height: 35px !important;
}
/* .video-mini {
  flex-grow: 1;
  width: 50%;
  height: auto;
  max-height: 250%;
  background: black;
  border-radius: 5px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -135px;
  position: absolute;
  margin-left: 10px;
}
.video-mini video {
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
  height: 125px;
} */

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
